import { Loc } from 'main.core';
import { NoticeBase } from 'b24network.vue.cross-scenario-shared-js';

/**
 * When user tries to enter portal that not exists
 */
export class UnknownPortal extends NoticeBase
{
	constructor()
	{
		super(
			Loc.getMessage('EXT_B24NET_LOGGING_IN_INVALID_B24', { '[br]': '<br>' }),
			Loc.getMessage('EXT_B24NET_LOGGING_IN_NO_B24_LIKE_THIS'),
		);
	}
}
